import { getCountry } from './countries.js';
/** Country → admin area level 1. Empty arrays mean city is free-text only. */
const DIVISIONS = {
    JO: [
        { code: 'JO-AM', name: 'Amman' },
        { code: 'JO-IR', name: 'Irbid' },
        { code: 'JO-AZ', name: 'Zarqa' },
        { code: 'JO-AQ', name: 'Aqaba' },
        { code: 'JO-BA', name: 'Balqa' },
        { code: 'JO-MD', name: 'Madaba' },
        { code: 'JO-KA', name: 'Karak' },
        { code: 'JO-AT', name: 'Tafilah' },
        { code: 'JO-MN', name: "Ma'an" },
        { code: 'JO-JA', name: 'Jerash' },
        { code: 'JO-AJ', name: 'Ajloun' },
        { code: 'JO-MA', name: 'Mafraq' },
    ],
    SA: [
        { code: 'SA-01', name: 'Riyadh' },
        { code: 'SA-02', name: 'Makkah' },
        { code: 'SA-03', name: 'Madinah' },
        { code: 'SA-04', name: 'Eastern Province' },
        { code: 'SA-05', name: 'Al-Qassim' },
        { code: 'SA-06', name: 'Ha\'il' },
        { code: 'SA-07', name: 'Tabuk' },
        { code: 'SA-08', name: 'Northern Borders' },
        { code: 'SA-09', name: 'Jazan' },
        { code: 'SA-10', name: 'Najran' },
        { code: 'SA-11', name: 'Al-Bahah' },
        { code: 'SA-12', name: 'Al-Jawf' },
        { code: 'SA-14', name: "'Asir" },
    ],
    SY: [
        { code: 'SY-DI', name: 'Damascus' },
        { code: 'SY-RD', name: 'Rif Dimashq' },
        { code: 'SY-HL', name: 'Aleppo' },
        { code: 'SY-HM', name: 'Homs' },
        { code: 'SY-HI', name: 'Hama' },
        { code: 'SY-LA', name: 'Latakia' },
        { code: 'SY-ID', name: 'Idlib' },
        { code: 'SY-TA', name: 'Tartus' },
        { code: 'SY-RA', name: 'Raqqa' },
        { code: 'SY-DY', name: 'Deir ez-Zor' },
        { code: 'SY-HA', name: 'Hasakah' },
        { code: 'SY-DR', name: 'Daraa' },
        { code: 'SY-SU', name: 'As-Suwayda' },
        { code: 'SY-QU', name: 'Quneitra' },
    ],
    IQ: [
        { code: 'IQ-BG', name: 'Baghdad' },
        { code: 'IQ-BA', name: 'Basra' },
        { code: 'IQ-NI', name: 'Nineveh' },
        { code: 'IQ-AR', name: 'Erbil' },
        { code: 'IQ-SU', name: 'Sulaymaniyah' },
        { code: 'IQ-DA', name: 'Dohuk' },
        { code: 'IQ-AN', name: 'Anbar' },
        { code: 'IQ-BB', name: 'Babylon' },
        { code: 'IQ-KA', name: 'Karbala' },
        { code: 'IQ-NA', name: 'Najaf' },
        { code: 'IQ-WA', name: 'Wasit' },
        { code: 'IQ-SD', name: 'Saladin' },
        { code: 'IQ-DI', name: 'Diyala' },
        { code: 'IQ-QA', name: 'Al-Qadisiyyah' },
        { code: 'IQ-MU', name: 'Muthanna' },
        { code: 'IQ-MA', name: 'Maysan' },
        { code: 'IQ-DQ', name: 'Dhi Qar' },
        { code: 'IQ-KI', name: 'Kirkuk' },
    ],
    PS: [
        { code: 'PS-RB', name: 'Ramallah and Al-Bireh' },
        { code: 'PS-NB', name: 'Nablus' },
        { code: 'PS-HB', name: 'Hebron' },
        { code: 'PS-JN', name: 'Jenin' },
        { code: 'PS-TB', name: 'Tubas' },
        { code: 'PS-TK', name: 'Tulkarm' },
        { code: 'PS-QO', name: 'Qalqilya' },
        { code: 'PS-SL', name: 'Salfit' },
        { code: 'PS-JR', name: 'Jericho' },
        { code: 'PS-JE', name: 'Jerusalem' },
        { code: 'PS-BM', name: 'Bethlehem' },
        { code: 'PS-GZ', name: 'Gaza' },
        { code: 'PS-NG', name: 'North Gaza' },
        { code: 'PS-DE', name: 'Deir al-Balah' },
        { code: 'PS-KH', name: 'Khan Yunis' },
        { code: 'PS-RF', name: 'Rafah' },
    ],
    AE: [
        { code: 'AE-AZ', name: 'Abu Dhabi' },
        { code: 'AE-DU', name: 'Dubai' },
        { code: 'AE-SH', name: 'Sharjah' },
        { code: 'AE-AJ', name: 'Ajman' },
        { code: 'AE-UQ', name: 'Umm Al Quwain' },
        { code: 'AE-RK', name: 'Ras Al Khaimah' },
        { code: 'AE-FU', name: 'Fujairah' },
    ],
};
const DEFAULT_DIVISION_LABEL = 'State/Province';
export function getAdministrativeDivisions(countryCode) {
    return DIVISIONS[countryCode.toUpperCase()] ?? [];
}
export function getAdministrativeDivisionLabel(countryCode) {
    return getCountry(countryCode)?.administrativeDivisionLabel ?? DEFAULT_DIVISION_LABEL;
}
/** Divisions + label for cascading country → admin area UI. */
export function getLocationCascade(countryCode) {
    return {
        administrativeDivisionLabel: getAdministrativeDivisionLabel(countryCode),
        divisions: getAdministrativeDivisions(countryCode),
    };
}
/**
 * When the country changes, keep `administrativeAreaLevel1` only if it is still
 * valid for the new country. Countries with no curated list keep free-text values.
 */
export function cascadeAdministrativeArea(countryCode, administrativeAreaLevel1) {
    if (administrativeAreaLevel1 == null || administrativeAreaLevel1 === '')
        return null;
    const divisions = getAdministrativeDivisions(countryCode);
    if (divisions.length === 0)
        return administrativeAreaLevel1;
    const match = divisions.find((d) => d.code === administrativeAreaLevel1 || d.name === administrativeAreaLevel1);
    return match ? match.code : null;
}
//# sourceMappingURL=administrativeDivisions.js.map